import React from 'react';
import { BookOpen, FileText, HelpCircle } from 'lucide-react';
import Navbar from '@/components/landing/Navbar';
import Footer from '@/components/landing/Footer';
import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';

const Resources = () => {
  const resources = [
    {
      icon: FileText,
      title: 'Documentation',
      description: 'Complete guides and API documentation for integration',
      link: '#'
    },
    {
      icon: BookOpen,
      title: 'User Guides',
      description: 'Step-by-step tutorials to help you get started',
      link: '#'
    },
    {
      icon: HelpCircle,
      title: 'FAQs',
      description: 'Answers to frequently asked questions',
      link: '/#faq'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Resources and Guides"
        description="Documentation, user guides, and FAQs to help you get the most out of Boxd Logistics."
        keywords="boxd logistics documentation, shipping guides, api docs, ecommerce resources"
        canonical="https://boxdlogistics.in/resources"
      />
      <Navbar />
      
      <section className="relative pt-32 pb-20 px-4 bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="max-w-5xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-700 to-blue-800 rounded-full mb-6">
            <BookOpen className="w-10 h-10 text-white" />
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            <span className="bg-gradient-to-r from-blue-800 to-blue-950 bg-clip-text text-transparent">
              Resources
            </span>
          </h1>
          
          <p className="text-xl text-gray-600">
            Everything you need to know about shipping with Boxd Logistics
          </p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {resources.map((resource, index) => {
              const Icon = resource.icon;
              return (
                <a
                  key={index}
                  href={resource.link}
                  className="group p-8 bg-white rounded-2xl border-2 border-gray-200 hover:border-blue-500 hover:shadow-xl transition-all duration-300"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-700 to-blue-800 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-blue-800 transition-colors">
                    {resource.title}
                  </h3>
                  <p className="text-gray-600">{resource.description}</p>
                </a>
              );
            })}
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Resources;